var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contents"},[_c('goods-class-title',{attrs:{"imgwidth":527,"src":require('@/assets/images/goodsclass.png')}}),_vm._v(" "),_c('div',{staticClass:"brandlist"},[_c('ul',_vm._l((_vm.classinfos),function(classinfo,index){return _c('li',{key:index,class:{
          rightone: (index + 1) % 7 == 0 || index + 1 == _vm.classinfos.length,
          leftone: (index + 1) % 8 == 0
        }},[_c('goods-class-item',{attrs:{"classinfo":classinfo,"type":index < _vm.classinfos.length - 1}})],1)}),0)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a54a79f2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/GoodsClass.vue
// module id = null
// module chunks = 